import { initializeApp } from "firebase/app";
import { getToken, Messaging } from "firebase/messaging";

const config = {
  apiKey: "AIzaSyAYyyfp-64RflHUTc5wD4nK8cHLutoLmFA",
  authDomain: "sellar.firebaseapp.com",
  databaseURL: "https://sellar.firebaseio.com",
  projectId: "sellar",
  storageBucket: "sellar-partner-images",
  messagingSenderId: "197354963741",
  appId: "1:197354963741:web:acd16cc43d8fbb59b2d7f4",
  measurementId: "G-C5RSWZRC2W",
};
const testConfig = {
  apiKey: "AIzaSyCvi_0fhdF--64uLZiPmuHFR1x8SXvC4sY",
  authDomain: "sellar-test.firebaseapp.com",
  databaseURL: "https://sellar-test.firebaseio.com",
  projectId: "sellar-test",
  messagingSenderId: "907403682172",
  storageBucket: "gs://sellar-test.appspot.com",
  appId: "1:907403682172:web:9378a6f90ff8a4509884f9",
};

export const firebaseApp = initializeApp(
  import.meta.env.VITE_ENV === "production" ? config : testConfig,
);

export const getFirebaseMessagingToken = async (
  firebaseMessaging: Messaging,
): Promise<string | undefined> => {
  return await getToken(firebaseMessaging, {
    vapidKey: import.meta.env.FBPUSH_VAPID_KEY,
  }).then((currentToken) => currentToken);
};
